import { NumericFormat } from 'react-number-format';
import TextField from '@mui/material/TextField';

export default function PayInput({ value, onChange, label }) {
  return (
    <NumericFormat
      fullWidth
      customInput={TextField}
      label={label}
      value={value}
      onValueChange={(values) => {
        onChange(values.floatValue); // floatValue is number or undefined
      }}
      thousandSeparator
      prefix="$"
      decimalScale={2}
      fixedDecimalScale
      allowNegative={false}
      variant="standard"
    />
  );
}